import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Uploads } from "../../../services/uploads";
import { Globals } from '../../../../globals';
import { TranslateService } from '@ngx-translate/core';
import { StaticsServices } from '../../../services/statics';
import { ComboServices } from '../../services';
import { MenuServices } from '../../../menu/services';

/**
 * Generated class for the ComboCreateImagePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-combo-create-image',
  templateUrl: 'combo-create-image.html',
})
export class ComboCreateImagePage {

  update_state: boolean = false;
  combo_uid: string;
  img_ref: string = null;
  selectedFiles: FileList;
  combo_name: string;
  combo: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public uploadServices: Uploads,
    private alertCtrl: AlertController,
    public globals: Globals,
    public translate: TranslateService,
    public staticsServices: StaticsServices,
    public comboServices: ComboServices,
    public menuServices: MenuServices,) {

    this.update_state = this.navParams.get('update');
    this.combo_uid = this.navParams.get('combo_uid');
    this.img_ref = this.navParams.get('image');
    this.combo_name = this.navParams.get('combo_name');
    this.combo = this.navParams.get('combo');

  }

  ionViewWillEnter() {
    if (this.img_ref != '') {
      this.getImageUrl(this.img_ref);
    }
  }

  ionViewWillLeave() {
    this.comboServices.image_url_combo_view = null;
  }

  async selectFile(event) {
    const file = event.target.files.item(0)
    if (file.type.match('image.*')) {
      this.selectedFiles = event.target.files;//File selected
      // cambiar el nombre de los archivos
      this.selectedFiles = this.globals.RenameFiles(this.selectedFiles, this.combo_uid)

      this.img_ref = await this.uploadServices.uploadComplete(this.selectedFiles, 'combo') //Upload file to firbase storage
      this.update() //Update data to firestore
      this.getImageUrl(this.img_ref); //Get url from image uploaded
    } else {
      alert('invalid format!');
    }
  }

  getImageUrl(image_ref) {
    //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.uploadServices.storage.ref(image_ref);
    this.comboServices.image_url_combo_view = ref.getDownloadURL();
  }

  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-imagen'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-imagen'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Combo', 'Combo - Image - Delete', this.globals.restaurant.email, 'Delete', 'Delete image', 'Combo', this.combo_name);
            //this.uploadServices.delete(this.img_ref);
            this.comboServices.image_url_combo_view = null;
            this.img_ref = null;
            this.update();
          }
        }
      ]
    });
    alert.present();
  }

  update() {
    this.comboServices.afs.collection('menus').doc(this.combo_uid).update({
      'image': this.img_ref,
    }).then(() => {
      this.globals.GAtrackView('Combo', 'Combo - Image - Create', this.globals.restaurant.email, 'Create/Update', 'Create image', 'Combo', this.combo_name);
      //statics
      this.staticsServices.changeStateStaticWait(true);
    });
  }


  saveComboImage() {
    //pop page
    this.navCtrl.pop();

  }
}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-image/combo-create-image.ts